export const CLIENT_NUTRITION_DEFAULT_PURPOSE = "fallback";
export const CLIENT_NUTRITION_STATUS_ACTIVE = "active";
export const CLIENT_NUTRITION_STATUS_ARCHIVED = "archived";

const NUTRITION_COLLECTION = "nutrition";
const NUTRITION_ROOT_DOC = "current";
const NUTRITION_FOODS_COLLECTION = "foods";
const NUTRITION_RECIPES_COLLECTION = "recipes";
const NUTRITION_EQUIVALENTS_COLLECTION = "equivalents";
const NUTRITION_PLANS_COLLECTION = "nutrition_plans";

function normalizeDocId(value, fallback = "") {
  const resolvedValue = String(value ?? fallback).trim();
  return resolvedValue.length > 0 ? resolvedValue.toLowerCase() : String(fallback || "");
}

export function buildNutritionRootDocPath(coachId) {
  return [
    "coaches",
    String(coachId),
    NUTRITION_COLLECTION,
    NUTRITION_ROOT_DOC,
  ];
}

export function buildNutritionFoodsCollectionPath(coachId) {
  return [...buildNutritionRootDocPath(coachId), NUTRITION_FOODS_COLLECTION];
}

export function buildNutritionFoodDocPath(coachId, foodId) {
  return [...buildNutritionFoodsCollectionPath(coachId), normalizeDocId(foodId)];
}

export function buildNutritionRecipesCollectionPath(coachId) {
  return [...buildNutritionRootDocPath(coachId), NUTRITION_RECIPES_COLLECTION];
}

export function buildNutritionRecipeDocPath(coachId, recipeId) {
  return [...buildNutritionRecipesCollectionPath(coachId), normalizeDocId(recipeId)];
}

export function buildNutritionEquivalentsCollectionPath(coachId) {
  return [...buildNutritionRootDocPath(coachId), NUTRITION_EQUIVALENTS_COLLECTION];
}

export function buildNutritionEquivalentDocPath(coachId, equivalentId) {
  return [
    ...buildNutritionEquivalentsCollectionPath(coachId),
    normalizeDocId(equivalentId),
  ];
}

export function buildNutritionPlansCollectionPath(coachId) {
  return [...buildNutritionRootDocPath(coachId), NUTRITION_PLANS_COLLECTION];
}

export function buildNutritionPlanDocPath(coachId, planId) {
  return [...buildNutritionPlansCollectionPath(coachId), normalizeDocId(planId)];
}

export function buildNutritionPlanMealsCollectionPath(coachId, planId) {
  return [...buildNutritionPlanDocPath(coachId, planId), "meals"];
}

export function buildNutritionPlanMealDocPath(coachId, planId, mealId) {
  return [
    ...buildNutritionPlanMealsCollectionPath(coachId, planId),
    normalizeDocId(mealId),
  ];
}

export function buildClientNutritionRootDocPath(clientId) {
  return [
    "users",
    String(clientId),
    NUTRITION_COLLECTION,
    NUTRITION_ROOT_DOC,
  ];
}

export function buildClientNutritionPlansCollectionPath(clientId) {
  return [...buildClientNutritionRootDocPath(clientId), NUTRITION_PLANS_COLLECTION];
}

export function buildClientNutritionPlanDocPath(clientId, clientPlanId) {
  return [
    ...buildClientNutritionPlansCollectionPath(clientId),
    normalizeDocId(clientPlanId),
  ];
}

export function buildClientNutritionPlanMealsCollectionPath(clientId, clientPlanId) {
  return [...buildClientNutritionPlanDocPath(clientId, clientPlanId), "meals"];
}

export function buildClientNutritionPlanMealDocPath(clientId, clientPlanId, mealId) {
  return [
    ...buildClientNutritionPlanMealsCollectionPath(clientId, clientPlanId),
    normalizeDocId(mealId),
  ];
}

export function buildPendingClientNutritionRootDocPath(coachId, pendingUserId) {
  return [
    "coaches",
    String(coachId),
    "pending_users",
    String(pendingUserId),
    NUTRITION_COLLECTION,
    NUTRITION_ROOT_DOC,
  ];
}

export function buildPendingClientNutritionPlansCollectionPath(coachId, pendingUserId) {
  return [
    ...buildPendingClientNutritionRootDocPath(coachId, pendingUserId),
    NUTRITION_PLANS_COLLECTION,
  ];
}

export function buildPendingClientNutritionPlanDocPath(
  coachId,
  pendingUserId,
  clientPlanId,
) {
  return [
    ...buildPendingClientNutritionPlansCollectionPath(coachId, pendingUserId),
    normalizeDocId(clientPlanId),
  ];
}

export function buildPendingClientNutritionPlanMealsCollectionPath(
  coachId,
  pendingUserId,
  clientPlanId,
) {
  return [
    ...buildPendingClientNutritionPlanDocPath(
      coachId,
      pendingUserId,
      clientPlanId,
    ),
    "meals",
  ];
}

export function buildPendingClientNutritionPlanMealDocPath(
  coachId,
  pendingUserId,
  clientPlanId,
  mealId,
) {
  return [
    ...buildPendingClientNutritionPlanMealsCollectionPath(
      coachId,
      pendingUserId,
      clientPlanId,
    ),
    normalizeDocId(mealId),
  ];
}
